module.exports = __webpack_public_path__ + "img/9788937442049.ec767a0e.jpg";